<template>
  <div id="app" :class="['has-sidenav', 'has-dropnav', globalStateClasses]">
    <nav-bar></nav-bar>
    <!-- <drawer></drawer> -->

    <div class="app-body">
      <transition name="fade" mode="out-in" @before-enter="beforeEnter" appear>
        <router-view></router-view>
      </transition>
    </div>

    <toasts></toasts>
    <modal-manager></modal-manager>
    <overlay-manager></overlay-manager>

    <footer-bar></footer-bar>
  </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex';

  // Components
  import NavBar from './NavBar.vue';
  // import Drawer from './Drawer.vue';
  import FooterBar from './FooterBar.vue';

  export default {
    name: 'Root',
    
    metaData() {
      return {
        meta: [
          { property: 'og:image', content: this.$speak('app.meta.og_image') },
          { property: 'og:type', content: this.$speak('app.meta.og_type') },
          { property: 'og:url', content: window.location.href },
          { property: 'og:author', content: this.$speak('app.meta.og_author') },
          { property: 'og:publisher', content: this.$speak('app.meta.og_publisher') },
        ]
      }
    },
    
    components: {
      NavBar,
      // Drawer,
      FooterBar
    },

    computed: {
      ...mapGetters([
        'global',
        'drawer'
      ]),

      globalStateClasses () {
        return {
          'has-sidenav--is-open': this.global.isSideNavActive,
          // 'has-drawer--is-open': this.drawer.isDrawerActive,
          // 'has-drawer': this.drawer.hasDrawer
        }
      }
    },

    methods: {
      beforeEnter () {
        this.$root.$emit('scrollBeforeEnter');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/Root.vue